import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth/auth.service';
import { Router } from '@angular/router';
import { getUserProfile } from 'src/app/core/session';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  profile:any;
  role_id: number;
  constructor(private _auth: AuthService, private _router: Router) { 
    this._auth.userProfileData$.subscribe(data => {
      this.role_id = getUserProfile().role_id;
    })

    this.role_id = getUserProfile().role_id;
  }

  ngOnInit() {
    this._router.navigate(['app/finance-customer']);
  }

}
